var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-left"
  }, _vm._l((_vm.itemList), function(formItem, index) {
    return _c('div', {
      key: index
    }, [(_vm.edit) ? _c('div', [(formItem.show) ? _c('FormItem', {
      attrs: {
        "label": formItem.label,
        "prop": formItem.prop
      }
    }, [(formItem.type === 'select') ? _c('Select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "filterable": "",
        "disabled": formItem.disabled,
        "filterable": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, _vm._l((formItem.selectList), function(item, index) {
      return _c('Option', {
        key: index,
        attrs: {
          "value": item.name,
          "label": item.name
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "nowrap",
        staticStyle: {
          "float": "right",
          "color": "#ccc"
        }
      }, [_vm._v(_vm._s(item.code))])])
    }), 1) : (formItem.type == 'selector') ? _c('BaseSelect', {
      attrs: {
        "type": formItem.datatype,
        "value": formItem.value,
        "autoload": formItem.autoload,
        "parameter": formItem.parameter
      },
      on: {
        "change": function($event) {
          return _vm.selectorchange(index, $event)
        }
      }
    }) : (formItem.type === 'input') ? _c('Input', {
      attrs: {
        "disabled": formItem.disabled
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }) : (formItem.type === 'textarea') ? _c('Input', {
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": "请输入"
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }) : (formItem.type === 'switch') ? _c('i-switch', {
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, [_c('span', {
      attrs: {
        "slot": "open"
      },
      slot: "open"
    }, [_vm._v("是")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "close"
      },
      slot: "close"
    }, [_vm._v("否")])]) : (formItem.type === 'DatePicker') ? _c('DatePicker', {
      attrs: {
        "type": "date",
        "disabled": formItem.disabled,
        "value": formItem.value,
        "clearable": false,
        "options": formItem.pickerOptions,
        "placeholder": "请选择"
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      }
    }) : (formItem.type === 'text') ? _c('div', [_vm._v(_vm._s(formItem.value))]) : _vm._e()], 1) : _vm._e()], 1) : _c('div', [(formItem.show) ? _c('FormItem', {
      attrs: {
        "label": formItem.label,
        "prop": formItem.prop
      }
    }, [(formItem.type === 'switch') ? _c('i-switch', {
      attrs: {
        "disabled": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, [_c('span', {
      attrs: {
        "slot": "open"
      },
      slot: "open"
    }, [_vm._v("是")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "close"
      },
      slot: "close"
    }, [_vm._v("否")])]) : (formItem.type == 'selector' && formItem.value && formItem.value.name) ? _c('span', [_vm._v(_vm._s(formItem.value.name))]) : _c('span', [_vm._v(_vm._s(formItem.value))])], 1) : _vm._e()], 1)])
  }), 0)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba42fa8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormDetailLeft/index.vue
// module id = GREp
// module chunks = 142